import { DynamicStandaloneTag, DynamicStandaloneTagProps } from '@/components/Tag';
import { componentTheme } from '@/styles/SavedArticles';
import mergeProps from 'lib/utils/mergeProps';
import type { StandaloneComponent } from 'types/component';

export type SavedArticlesTagProps = DynamicStandaloneTagProps;

export const SavedArticlesTagComponent: StandaloneComponent<DynamicStandaloneTagProps> = (props) => {
  return (
    <DynamicStandaloneTag
      {...mergeProps(
        {
          options: {
            theme: componentTheme('tag'),
          },
        },
        props
      )}
    />
  );
};
